module.exports = __webpack_public_path__ + "static/media/news-1.6db9a88e.jpg";